export default __webpack_public_path__ + "static/media/greenrectangle.4ffec3f6.png";